import { render, staticRenderFns } from "./WritingEN.vue?vue&type=template&id=b96a8e4c&scoped=true&"
import script from "./WritingEN.vue?vue&type=script&lang=js&"
export * from "./WritingEN.vue?vue&type=script&lang=js&"
import style0 from "./WritingEN.vue?vue&type=style&index=0&id=b96a8e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96a8e4c",
  null
  
)

export default component.exports